import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { formatEventDate } from "@/lib/format";
import { Calendar, MapPin, Ticket } from "lucide-react";
import EmptyState from "@/components/EmptyState";

export default function MyTicketsPage() {
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/me/tickets").then((r) => setTickets(r.data)).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="z-container" style={{ textAlign: "center" }}><span className="z-loader z-loader-dark" /></div>;

  return (
    <div className="z-container" data-testid="my-tickets-page">
      <h1 className="z-page-title">Mes billets</h1>
      <p className="z-page-sub">{tickets.length} billet(s) — présentez le QR à l'entrée.</p>

      {tickets.length === 0 ? (
        <EmptyState
          icon={<Ticket size={28} />}
          title="Aucun billet pour l'instant"
          message="Explorez les événements et réservez le vôtre."
          testId="my-tickets-empty"
        >
          <Link to="/events" className="z-btn z-btn-primary">Explorer</Link>
        </EmptyState>
      ) : (
        <div style={{ display: "grid", gap: 12 }}>
          {tickets.map((t) => (
            <Link key={t.id} to={`/ticket/${t.id}`} className="z-card" style={{ padding: 16, display: "flex", gap: 14, textDecoration: "none", color: "inherit" }} data-testid={`ticket-item-${t.id}`}>
              {t.event?.image_url && (
                <img src={t.event.image_url} alt="" style={{ width: 72, height: 72, borderRadius: 12, objectFit: "cover" }} />
              )}
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 700, marginBottom: 4 }}>{t.event?.title}</div>
                <div style={{ fontSize: 12, color: "var(--z-muted)", display: "flex", alignItems: "center", gap: 4 }}>
                  <Calendar size={12} /> {formatEventDate(t.event?.starts_at)}
                </div>
                <div style={{ fontSize: 12, color: "var(--z-muted)", display: "flex", alignItems: "center", gap: 4 }}>
                  <MapPin size={12} /> {t.event?.location || "Lieu communiqué"}
                </div>
                <div style={{ marginTop: 6 }}>
                  {t.status === "scanned" ? (
                    <span className="z-badge" style={{ background: "rgba(161,44,123,0.12)", color: "var(--z-error)" }}>Scanné</span>
                  ) : (
                    <span className="z-badge z-badge-success">Valide</span>
                  )}
                  {t.is_invitation && <span className="z-badge z-badge-teal" style={{ marginLeft: 6 }}>Invitation</span>}
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
